import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

//stores query based search input

interface SearchState {
    searches: {
        [key: string]: string;
    };
    setSearch: (key: string, query: string) => void;
    clearSearch: (key: string) => void;
    getSearch: (key: string) => string;
}

const useSearchStore = create<SearchState>()(
    persist(
        (set, get) => ({
            searches: {},
            setSearch: (key, query) =>
                set(() => ({
                    searches: { ...get().searches, [key]: query },
                })),
            clearSearch: (key) =>
                set(() => {
                    const searches = get().searches;
                    delete searches[key];
                    return { searches };
                }),
            getSearch: (key) => get().searches[key] ?? "",
        }),
        {
            name: "searches",
            storage: createJSONStorage(() => sessionStorage),
        }
    )
);

export default useSearchStore;